import React from "react";
import { Col } from "react-bootstrap";
import CommitmentPerson from "./CommitmentPerson";
import "./CommitmentPeopleList.css";

function CommitmentPeopleList({ people, language }) {
  return (
    <Col className="commitments-people-list">
      {people.map((element) => (
        <CommitmentPerson
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
        />
      ))}
    </Col>
  );
}

export default CommitmentPeopleList;
